import { render, staticRenderFns } from "./DocumentViewDetails.vue?vue&type=template&id=1bee55a0&scoped=true"
import script from "./DocumentViewDetails.vue?vue&type=script&lang=js"
export * from "./DocumentViewDetails.vue?vue&type=script&lang=js"
import style0 from "./DocumentViewDetails.vue?vue&type=style&index=0&id=1bee55a0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bee55a0",
  null
  
)

export default component.exports